import { useAppStore } from '@/store/useAppStore'

const ADMIN_USER_ID = 'c4a0b17f-5e5c-4fe7-9097-20a5e56050d2'

export function useIsAdmin(): boolean {
  const { user } = useAppStore()
  return user?.id === ADMIN_USER_ID
}
